import { render, staticRenderFns } from "./resource-details.vue?vue&type=template&id=10cf4911&"
import script from "./resource-details.vue?vue&type=script&lang=js&"
export * from "./resource-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports